var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "train" } }, [
    _vm.$route.query.tabIndex
      ? _c("div", { attrs: { id: "Return_Bar" } }, [
          _c("i", { staticClass: "el-icon-arrow-left" }),
          _vm._v(" "),
          _c("div", { staticClass: "isreturn", on: { click: _vm.isreturn } }, [
            _vm._v("返回")
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "video-box", staticStyle: { "padding-left": "20px" } },
      [
        _c(
          "div",
          {
            staticStyle: {
              width: "100%",
              height: "42px",
              "background-color": "#DDDDDD",
              "line-height": "36px",
              "font-size": "16px",
              "padding-left": "10px"
            }
          },
          [
            _vm._v(
              "\n      请认真选择，系统会根据你选择的结果来匹配，准确率越高任务录取率越高，如存在弄虚作假的情况，平台将做永久封禁处理。\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "el-form",
          { attrs: { inline: true } },
          [
            _c(
              "el-form-item",
              { staticStyle: { width: "700px" } },
              [
                _c("el-link", { attrs: { type: "info", underline: false } }, [
                  _vm._v("1、选择自己的在线经验【多选】")
                ]),
                _vm._v(" "),
                _c("el-tree", {
                  ref: "tree",
                  staticStyle: { width: "500px" },
                  attrs: {
                    data: _vm.experience.list,
                    props: _vm.props,
                    "default-checked-keys": _vm.experience.defaultCheckedArr,
                    "node-key": "operationTagId",
                    "show-checkbox": "",
                    "check-strictly": true,
                    "default-expand-all": false
                  },
                  on: { check: _vm.checkChildrenChecked },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var node = ref.node
                        var data = ref.data
                        return _c(
                          "span",
                          {
                            staticClass: "aaa",
                            staticStyle: {
                              height: "27px",
                              "line-height": "26px",
                              width: "100%",
                              border: "1px solid #D3D6DB"
                            }
                          },
                          [
                            _c("span", { staticStyle: { width: "100%" } }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    width: "200px",
                                    "margin-left": "10px"
                                  }
                                },
                                [_vm._v(_vm._s(node.label.operationTagName))]
                              )
                            ])
                          ]
                        )
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c(
                  "el-link",
                  {
                    staticStyle: { "margin-top": "20px" },
                    attrs: { type: "info", underline: false }
                  },
                  [_vm._v("2、选择自己的意向班次【多选】")]
                ),
                _vm._v(" "),
                _c(
                  "el-checkbox-group",
                  {
                    staticStyle: { width: "500px", "margin-left": "44px" },
                    model: {
                      value: _vm.intent_schedule_hour.defaultCheckedArr,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.intent_schedule_hour,
                          "defaultCheckedArr",
                          $$v
                        )
                      },
                      expression: "intent_schedule_hour.defaultCheckedArr"
                    }
                  },
                  _vm._l(_vm.intent_schedule_hour.list, function(m) {
                    return _c(
                      "el-checkbox",
                      {
                        key: m.operationTagId,
                        staticClass: "radioOrCheckedBox",
                        attrs: { label: m.operationTagId }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { margin: "5px 0px 0px 10px" } },
                          [_vm._v(_vm._s(m.operationTagName))]
                        )
                      ]
                    )
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-link",
                  {
                    staticStyle: { "margin-top": "20px" },
                    attrs: { type: "info", underline: false }
                  },
                  [_vm._v("3、选择自己期望每天服务的时长【单选】")]
                ),
                _vm._v(" "),
                _c(
                  "el-radio-group",
                  {
                    staticStyle: { width: "500px", "margin-left": "44px" },
                    model: {
                      value: _vm.intent_serve_hour.value,
                      callback: function($$v) {
                        _vm.$set(_vm.intent_serve_hour, "value", $$v)
                      },
                      expression: "intent_serve_hour.value"
                    }
                  },
                  _vm._l(_vm.intent_serve_hour.list, function(m) {
                    return _c(
                      "el-radio",
                      {
                        key: m.operationTagId,
                        staticClass: "radioOrCheckedBox",
                        staticStyle: { "line-height": "26px" },
                        attrs: { label: m.operationTagId }
                      },
                      [_vm._v(_vm._s(m.operationTagName))]
                    )
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { width: "100%", "margin-top": "20px" } },
                  [
                    _vm.$route.query.tabIndex
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "26px" },
                            attrs: { type: "primary", size: "small" },
                            on: { click: _vm.isreturn }
                          },
                          [_vm._v("取消")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.saveLabel }
                      },
                      [_vm._v("保存")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br")
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-425512ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-425512ea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/fbtExperienceChoose.vue
// module id = 1133
// module chunks = 0